import { UserLevel } from '@infuse/iam/user/type';

export function getLevel(asset: { organisationId?: string; tenantId?: string }) {
  if (asset.organisationId) {
    return UserLevel.ORGANISATION;
  } else if (asset.tenantId) {
    return UserLevel.TENANT;
  } else {
    return UserLevel.DOMAIN;
  }
}
